import {SpaceProductSubType as UiSpaceProductSubType} from "entities/UIModel/SpaceProductSubType";
import {SpaceProductSubType as ApiSpaceProductSubType} from "entities/ApiModel/SpaceProductSubType";

export const mapToUiSpaceProductSubType = (s: ApiSpaceProductSubType) => {
  const uiSpaceProductSubType: UiSpaceProductSubType = {
    idProductSubType: s.IdProductSubType,
    product: s.Product,
    productSubType: s.ProductSubType,
    productSubTypeCode: s.ProductSubTypeCode,
    startDate: s.StartDate,
    endDate: s.EndDate,
  }

  return uiSpaceProductSubType;
}

export const mapToUiSpaceProductSubTypes = (data: ApiSpaceProductSubType[]) => {
  if (!data || data?.length === 0) {
    return [];
  }

  return data.map((d: ApiSpaceProductSubType) => {
    return mapToUiSpaceProductSubType(d);
  });  
}
